export class PreIronedInRevision {
    finalDate: Date
    initialDate: Date
    storeId: string
    material: string[]
} 